import BossModel from "@/models/BossModel";
import GeneralWebsiteProductTag from "@/models/WebsiteProduct/Tag/Tag";

export default class WebsiteProductTag extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/website-product-tag';

    /**
     *
     * @type {string}
     */
    static entity = 'productWebsiteProductTags';

    static fields() {
		return {
			id: this.number(null).nullable(),
			grade: this.attr(null),
			product_id: this.number(null).nullable(),
			website_product_tag_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            tag: this.belongsTo(GeneralWebsiteProductTag, 'website_product_tag_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    Tag() {
        return this.getRelated('tag');
    }
}
